/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Rating_Brea_TInputs */

const en_onboarding_rating_brea_t = /** @type {(inputs: Onboarding_Rating_Brea_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Useful everyday! This app legit turns anything into a podcast you can listen to in seconds. I can finally listen to all the newsletters and essays I'm subscribed to without spending hours in my email inbox! In particular I appreciate using this app for long walks, chores around the house, and exercise.`)
};

const es_onboarding_rating_brea_t = /** @type {(inputs: Onboarding_Rating_Brea_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Útil todos los días! Esta app literalmente convierte cualquier cosa en un podcast que puedes escuchar en segundos. ¡Por fin puedo escuchar todos los boletines y ensayos a los que estoy suscrito sin pasar horas en mi bandeja de entrada! En particular, aprecio usar esta app para caminatas largas, tareas del hogar y ejercicio.`)
};

/**
* | output |
* | --- |
* | "Useful everyday! This app legit turns anything into a podcast you can listen to in seconds. I can finally listen to all the newsletters and essays I'm subscr..." |
*
* @param {Onboarding_Rating_Brea_TInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_rating_brea_t = /** @type {((inputs?: Onboarding_Rating_Brea_TInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Rating_Brea_TInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_rating_brea_t(inputs)
	return en_onboarding_rating_brea_t(inputs)
});